import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  resetPassword,
  selectAuthResetPasswordError,
  selectAuthResetPasswordLoading,
} from '@/redux/modules/auth';

import ForgotPasswordForm, { ForgotPasswordFormFields, ForgotPasswordFormProps } from './component';

const ForgotPasswordFormContainer: React.FC<
  Omit<ForgotPasswordFormProps, 'loading' | 'error' | 'onSubmit'>
> = props => {
  const dispatch = useDispatch();
  const loading = useSelector(selectAuthResetPasswordLoading);
  const error = useSelector(selectAuthResetPasswordError);

  const handleSubmit = (formData: ForgotPasswordFormFields) => {
    dispatch(resetPassword({ email: formData.email }));
  };

  return <ForgotPasswordForm {...props} loading={loading} error={error} onSubmit={handleSubmit} />;
};

export default ForgotPasswordFormContainer;
